import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, WrenchIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const badges = [{
  icon: ShieldCheckIcon,
  text: 'Garantía de 7 días'
}, {
  icon: ZapIcon,
  text: 'Acceso inmediato al PDF'
}, {
  icon: WrenchIcon,
  text: 'Hecho para autos en Argentina'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950" data-id="element-47" data-mp="129h6c3bjvskt">
      <div className="grid-texture absolute inset-0" aria-hidden="true" data-id="element-48" data-mp="128pft6wt8l1e" />
      <div className="relative mx-auto grid max-w-6xl gap-10 px-4 pb-16 pt-12 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14 lg:pb-24 lg:pt-16" data-id="element-49" data-mp="xbpcv4v9byei">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-50" data-mp="ncgjoe87unt7">
          <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-amber-brand/40 bg-amber-brand/10 px-3 py-1 font-display text-sm font-bold uppercase tracking-[0.18em] text-amber-brand" data-id="element-51" data-mp="3cz5wsfzj282g">
            Método Mecánica Inteligente
          </p>
          <h1 className="font-display text-4xl font-bold uppercase leading-[0.98] text-white sm:text-5xl lg:text-6xl" data-id="element-52" data-mp="3o73mw4xwji4w">
            Dejá de sentirte un boludo cuando vas al mecánico
            <span className="mt-3 block text-amber-brand" data-id="element-53" data-mp="3e8ehhbn6zq5j">
              ¡Que no te caguen!
            </span>
          </h1>
          <p className="mt-5 max-w-xl font-display text-xl font-semibold uppercase leading-tight text-white/85 sm:text-2xl" data-id="element-54" data-mp="30gq4z7916zo1">
            Aprendé a detectar fallas, evitar reparaciones innecesarias y que
            nunca más te estafen en un taller.
          </p>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-55" data-mp="2vi55ja1lsk0n">
            El primer sistema de supervivencia mecánica diseñado para dueños de
            autos en Argentina. Ahorrá fortunas en mantenimiento y ganá la
            tranquilidad de saber exactamente qué pasa debajo de tu capó.
          </p>

          <div className="mt-8 max-w-xl" data-id="element-56" data-mp="s3cla9fddhq1">
            <CtaButton location="hero" subLabel="Pago único · Lo recibís en tu email al instante" data-id="element-57" data-mp="nbl2il2gggag" />
          </div>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-3" data-id="element-58" data-mp="ichyn3y7og42">
            {badges.map(({
            icon: Icon,
            text
          }) => <li key={text} className="flex items-center gap-2 text-sm text-white/55" data-id="element-59" data-mp="dbapb0gf78va">
                <Icon className="h-4 w-4 text-amber-brand" aria-hidden="true" data-id="element-60" data-mp="161aul0eu2nyo" />
                {text}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-61" data-mp="114kg2hiog0fd">
          <div className="overflow-hidden rounded-2xl border border-white/10 shadow-2xl shadow-black/60" data-id="element-62" data-mp="3hr3rrvrkeb5t">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/3785198c-47dd-4772-8f9e-b8341fd9ebe7.jpg" alt="Conductor consultando la guía de mecánica en su celular frente al motor abierto de su auto" className="h-full w-full object-cover" loading="eager" data-id="element-63" data-mp="1xacgb5dntnua" />
          </div>
          <div className="absolute -bottom-5 left-4 right-4 rounded-xl border border-amber-brand/30 bg-ink-900/95 px-4 py-3 backdrop-blur sm:left-8 sm:right-8" data-id="element-64" data-mp="2fzstotag1as4">
            <p className="text-center font-display text-lg font-bold uppercase text-white" data-id="element-65" data-mp="2kxc5lmjo5bgw">
              Entrá al taller sabiendo{' '}
              <span className="text-amber-brand" data-id="element-66" data-mp="2tzlg4cext4ua">exactamente</span> qué pedir
            </p>
          </div>
        </motion.div>
      </div>
    </header>;
}